<div class="pa-donut-wrap">
  <div class="pa-donut" *ngIf="total > 0">
    <svg viewBox="0 0 120 120" class="pa-donut__svg">
      <g transform="rotate(-90 60 60)">
        <circle cx="60" cy="60" r="50" fill="none" stroke="var(--pa-divider)" stroke-width="15"></circle>
        <circle *ngFor="let a of arcs" cx="60" cy="60" r="50" fill="none"
          [attr.stroke]="a.color" stroke-width="15"
          [attr.stroke-dasharray]="a.dash + ' ' + a.gap"
          [attr.stroke-dashoffset]="a.offset"></circle>
      </g>
      <text *ngIf="centerValue" x="60" y="57" text-anchor="middle" class="pa-donut__num">{{ centerValue }}</text>
      <text *ngIf="centerLabel" x="60" y="73" text-anchor="middle" class="pa-donut__lbl">{{ centerLabel }}</text>
    </svg>
  </div>
  <ul class="pa-donut__legend" *ngIf="showLegend">
    <li *ngFor="let s of segments">
      <span class="pa-dot" [style.background]="s.color"></span>
      <span class="pa-donut__name">{{ s.label }}</span>
      <b class="pa-donut__num2">{{ s.value }}</b>
    </li>
  </ul>
</div>
